import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import { SecondaryButton } from "Shared/Buttons";
import styled from "styled-components";
import * as actions from "src/store/actions/currentDeal";

const Btn = styled(SecondaryButton)`
    font-size: 0.625em;
    letter-spacing: normal;
    outline: 0;
    padding: 0.75em 0.5em;

    ${(props) => props.theme.breakpoints.up("tablet")} {
        font-size: 0.875em;
        padding: 0.5em;
    }
`;

interface Props {
    vin: string;
}

const ContinueDealerOfferButton = ({ vin, updateCurrentDeal }: Props & typeof mapDispatchToProps) => {
    const history = useHistory();
    const { t } = useTranslation();

    const handleClick = () => {
        updateCurrentDeal(vin);
        history.push(`/dealer-offer`);
    };

    return (
        <div id="ExploreMore">
            <Btn onClick={handleClick}>{t("DealerOffer.ContinueDealerOffer.CTA")}</Btn>
        </div>
    );
};

const mapDispatchToProps = {
    updateCurrentDeal: actions.updateCurrentDeal,
};

export default connect(undefined, mapDispatchToProps)(ContinueDealerOfferButton);
